export const toHtmlPage = (html: string = "") => {
  const _html = html.replace(/\n/g, "<br />");
  return `<!DOCTYPE html>
    <html>
    <head>
    <style>
        .page{
            line-height: 1;
            padding-right: 15px;
        }
    </style>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    </head>
    <body>
        <div class='page'>
            <div style="text-align:center">
                <div><pre>${_html}</pre></div>
            </div>
        </div>
    </body>
    </html>`;
};

export const toHtml = (html: string = "") => {
  const _html = html.replace(/\n/g, "<br />");
  return `<div style="text-align:center">
    <div><pre>${_html}</pre></div>
</div>`;
};
